import React, {Component} from "react";


class InputHidden extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}}
        this.props.onChange(e);
    }

    static getDerivedStateFromProps(props, state) {
        const name = "BLOCK_ITEM_" + props.blockItem.id + (props.blockItem.isArray ? "[]" : "");
        if (props.blockItem.values[0] !== state[name]) {
            const e = {target: {name: name, value: props.blockItem.values[0]}}
            props.onChange(e);
            return {
                [name]: props.blockItem.values[0]
            };
        }
    }

    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <input type="hidden"
                   className={this.props.blockItem.inputClass}
                   name={name}
                   value={this.state[name]}/>
        );
    }
}

export default InputHidden;